import Swal from 'sweetalert2';

export const showSuccess = (title, text = '') =>
  Swal.fire({ icon: 'success', title, text, confirmButtonColor: '#3085d6' });

export const showError = (title, text = '') =>
  Swal.fire({ icon: 'error', title, text, confirmButtonColor: '#d33' });

// Devuelve true si el usuario confirmó, false si canceló.
// Para acciones destructivas (eliminar), pasar { peligro: true } y un confirmText acorde.
export const showConfirm = async (title, text = '', opciones = {}) => {
  const { peligro = false, confirmText, cancelText = 'Cancelar' } = opciones;
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: peligro ? '#d33' : '#3085d6',
    cancelButtonColor: '#aaa',
    confirmButtonText: confirmText || (peligro ? 'Sí, eliminar' : 'Sí, continuar'),
    cancelButtonText: cancelText,
    reverseButtons: true,
    focusCancel: peligro, // en acciones peligrosas el foco arranca en Cancelar
  });
  return result.isConfirmed;
};